import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useI18n } from '@/i18n'
import EulaText from '@/views/EulaText.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Eula',
  emits: [
    'hideEula',
    'login',
    'smartcraftAcceptEula'
],
  setup(__props, { emit }) {

const { locale } = useI18n()

const EULA_VERSION = ref(3)
const language = ref(locale.value === 'sv' ? 'sv' : 'en')



const clickDecline = () => {
    if (sessionStorage.getItem("smartcraft_token")) sessionStorage.removeItem("smartcraft_token")
    emit('hideEula')
};

const clickAccept = () => {
    if (sessionStorage.getItem("smartcraft_token")) emit("smartcraftAcceptEula", sessionStorage.getItem("smartcraft_token") as string, EULA_VERSION, language)
    emit('login', EULA_VERSION.value, language.value)
};


return { __sfc: true,locale, EULA_VERSION, language, emit, clickDecline, clickAccept, EulaText }
}

})